import { router } from '@inertiajs/react'
import { useEffect } from 'react'
import { loadPostHog } from '@/lib/posthog'

/**
 * Tracks Inertia SPA navigations as PostHog pageviews.
 * Without this, only the initial page load would be tracked.
 */
export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    let cancelled = false
    let stopListening: (() => void) | undefined

    void loadPostHog().then((posthog) => {
      if (!posthog || cancelled) return

      posthog.capture('$pageview')
      stopListening = router.on('navigate', () => {
        posthog.capture('$pageview')
      })
    })

    return () => {
      cancelled = true
      stopListening?.()
    }
  }, [])

  return <>{children}</>
}
